import React, { useState, useEffect, useContext } from "react";
import useDebounce from "../hooks/useDebounce";

import Select from "../ui/Select/Select";

import { CampaignSuggestService } from "../utils/api";
import GlobalsContext from "../context/GlobalsContext";
import WsContext from "../context/WsContext";

import { canSelectCampaign } from "../utils/perm";

const CampaignsSelect = ({
  onSelect,
  searchParams = {},
  mustCheckDisabled,
  ...props
}) => {
  const globalsContext = useContext(GlobalsContext);
  const wsContext = useContext(WsContext);

  const [loading, setLoading] = useState(false);
  const [term, setTerm] = useState("");
  const [opts, setOptions] = useState(globalsContext.campaigns);
  const [disabled, setDisabled] = useState(false);
  const debTerm = useDebounce(term, 300);

  const onSearchChange = e => {
    setTerm(e.target.value);
  };

  const checkDisabled = () => {
    canSelectCampaign(globalsContext.permissions)
      .then(canSelect => {
        setDisabled(!canSelect);
        if (!canSelect) {
          onSelect({ label: "", value: "" });
        }

        if (props.value) {
          CampaignSuggestService({ id: props.value })
            .then(data => {
              console.log(props.value);
              console.log(data.campaigns);
              if (data.campaigns.length == 0) {
                onSelect({ label: "", value: "" });
                setOptions([]);
                setTerm("");
              }
            })
            .catch(e => {
              console.log(e);
            })
            .finally(() => {
              setLoading(false);
            });
        }
      })
      .catch(e => {
        console.log(e);
      });
  };

  useEffect(() => {
    //checkDisabled();
    //wsContext.eventEmitter.subscribe("cards_update", checkDisabled);
  }, [props.value]);

  useEffect(() => {
    setLoading(true);
    CampaignSuggestService({ ...searchParams, term: debTerm })
      .then(data => {
        setLoading(false);
        setOptions(data.campaigns);
      })
      .catch(e => {
        console.log(e);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [debTerm]);

  useEffect(() => {
    const exists = opts.find(opt => {
      return opt.value == props.value;
    });

    if (!props.value || exists) {
      return;
    }

    setLoading(true);

    CampaignSuggestService({ id: props.value })
      .then(data => {
        setOptions(data.campaigns);
      })
      .catch(e => {
        console.log(e);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [props.value]);

  return (
    <Select
      {...props}
      searchable={true}
      ajax={true}
      loading={loading}
      handleSearchChange={onSearchChange}
      options={opts}
      disabled={disabled}
      onSelect={onSelect}
    />
  );
};

export default CampaignsSelect;
